import { get, post } from '@/fn/ajax'
import { clean } from '@/fn/object'

export async function getCateList() {
  const res = await get('/api/cate/alist_json')
  return res
}
// 首页获取推荐课程banner轮播列表
export async function getRecommendList() {
  const res = await get('/api/lesson/recommend')
  return res
}

export async function getGeneralCateList() {
  const res = await get('/api/cate/getGeneralCate_json')
  return res
}

export async function getSubCateList(query: any) {
  const qdata = clean(query, [null, undefined, '', 0])
  const res = await get('/api/cate/getSubCate_json', qdata)
  return res
}

export async function queryList(query: any) {
  const qdata = clean(query, [null, undefined, '', 0])
  const res = await get('/api/res/alist', qdata)
  return res
}

export async function courseItem(query: any) {
  const qdata = clean(query, [null, undefined, '', 0])
  const res = await get('/api/lesson/detail', qdata)
  return res
}
export async function resourceItem(query: any) {
  const qdata = clean(query, [null, undefined, '', 0])
  const res = await get('/api/res/item', qdata)
  return res
}

export async function saveList(data: any) {
  const res = await post('/api/course/edit_json', data)
  return res
}

export async function sendRes(data: any) {
  const res = await post('/api/play/send_resource', data)
  return res
}

export async function getMyList() {
  const res = await get('/api/course/list_json')
  return res
}
